import { useCallback, useContext } from 'react'

import { Context } from './ModalContext'
import { Handler } from './types'

// eslint-disable-next-line @typescript-eslint/no-empty-function
const useModal = (
  modal: React.ReactNode,
  closeOnOverlayClick = true,
  onOverlayClick = () => null,
  dismissCallback = () => null
): [Handler, Handler] => {
  const { onPresent, onDismiss, setCloseOnOverlayClick, setOnOverlayDismiss, setDismissCallback } = useContext(Context)

  const onPresentCallback = useCallback(() => {
    onPresent(modal)
    setCloseOnOverlayClick(closeOnOverlayClick)
    setOnOverlayDismiss(() => onOverlayClick)
    setDismissCallback(() => dismissCallback)
  }, [modal, onPresent])

  return [onPresentCallback, onDismiss]
}

export default useModal
